<template>
  <table>
    <tbody>
      <tr class="total-costs">
        <td>
          <translate tag="strong"> Total stay </translate>
          <translate tag="p" class="no-fee"> No booking fees </translate>
        </td>
        <td>
          <pu-price :price="priceTotal" :display-original-price="true" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { MoneyType } from '../../../utility/money'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class BookingTotalStay extends Vue {
  @Prop()
  priceTotal: MoneyType
}

export default toNative(BookingTotalStay)
</script>
<style scoped>
table {
  font-size: var(--body);
}

tr {
  border-bottom: 1px solid var(--colour-page-background);
}

td:last-of-type {
  text-align: right;
}

.no-fee {
  font-size: var(--body);
}
</style>
